"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BasisTheoryTokenize", {
  enumerable: true,
  get: function () {
    return _BasisTheoryTokenize.BasisTheoryTokenize;
  }
});

var _BasisTheoryTokenize = require("./BasisTheoryTokenize");